import React from "react";
import {
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock
} from "react-bootstrap";
import { getRequestTypeTitle } from "helpers/RequestHelper";
import { renderReadonlyHorizontalForm } from "helpers/FormHelper";

export const getPrerenderValues = (type, request) => {
  switch (type) {
    case "approve":
      return setApproveVals(request);
    case "withdraw":
      return setWithdrawVals(request);
    case "withdrawReason":
      return setWithdrawReasonVals(request);
    case "unwithdraw":
      return setUnwithdrawVals(request);
    default:
      return null;
  }
};

const setApproveVals = request => {
  const { formatedtransactionnumber, modelnumber } = request;
  const tn = formatedtransactionnumber;
  const renderBody = () => {
    return (
      <p>
        Are you sure you want to approve request {tn} (<b>"{modelnumber}"</b>)?
      </p>
    );
  };

  return {
    title: `Request ${tn} Approval`,
    body: renderBody,
    button: "success",
    buttonText: "Yes, Approve.",
    buttonLoadingText: "Approving..."
  };
};

const setWithdrawVals = request => {
  const { formatedtransactionnumber, modelnumber } = request;
  const tn = formatedtransactionnumber;
  const renderBody = () => {
    return (
      <p>
        Are you sure you want to withdraw request {tn} (<b>"{modelnumber}"</b>)?
      </p>
    );
  };

  return {
    title: `Request ${tn} Withdrawal`,
    body: renderBody,
    button: "danger",
    buttonText: "Yes, Withdraw.",
    buttonLoadingText: "Withdrawing..."
  };
};

const setUnwithdrawVals = request => {
  const { formatedtransactionnumber, modelnumber } = request;
  const tn = formatedtransactionnumber;
  const renderBody = () => {
    return (
      <p>
        Are you sure you want to unwithdraw request {tn} (<b>"{modelnumber}"</b>
        )?
      </p>
    );
  };

  return {
    title: `Request ${tn} Unwithdrawal`,
    body: renderBody,
    button: "success",
    buttonText: "Yes, Unwithdraw.",
    buttonLoadingText: "Unwithdrawing..."
  };
};

const setWithdrawReasonVals = request => {
  const {
    formatedtransactionnumber,
    modelnumber,
    name,
    requesttypeid
  } = request;
  const tn = formatedtransactionnumber;
  const formFields = [
    {
      title: "Request Type",
      value: getRequestTypeTitle(requesttypeid)
    },
    {
      title: "Manufacturer",
      value: name
    },
    {
      title: "Model Name/Number",
      value: modelnumber
    }
  ];
  const renderBody = (isFormValid, onValidate) => {
    const onChange = event => onValidate(event.target.value);
    return (
      <div>
        {renderReadonlyHorizontalForm(formFields)}
        <hr />
        <FormGroup validationState={getValidationState(isFormValid)}>
          <ControlLabel>
            Please enter the reason for withdrawing this request:
          </ControlLabel>
          <FormControl
            componentClass="textarea"
            id="reasonRef"
            style={{ height: 50 }}
            onChange={onChange}
          />
          {isFormValid ? null : (
            <HelpBlock>
              The reason must be at least 5 characters or longer.
            </HelpBlock>
          )}
        </FormGroup>
      </div>
    );
  };

  return {
    title: `Request ${tn} Withdrawal`,
    body: renderBody,
    button: "danger",
    buttonText: "Withdraw",
    buttonLoadingText: "Withdrawing..."
  };
};

const getValidationState = isValid => {
  return isValid ? null : "error";
};



// WEBPACK FOOTER //
// ./src/components/ModalConfirm/types.js